<template>
  <div class="animated fadeIn demo-split">
    <Split v-model="split1">
      <div slot="left" class="demo-split-pane">
        <Row>
          <Col span="24">
            <Tree :data="logTreeData" :load-data="onLoadChildrenData" :render="renderContent"></Tree>
          </Col>
        </Row>
      </div>
      <div slot="right" class="demo-split-pane">
        <div style="position:relative;">
          <Row style="margin-bottom: 2px;">
            <label>当前查看文件：</label>
            <Input size="small" readonly="readonly" style="width: 300px;" :value="currentFileName"></Input>
            <Button type="primary" size="small" style="margin-left: 2px;" @click="onRefresh">刷新</Button>
          </Row>
          <Row>
            <textarea ref="fileTextArea" wrap="off" readonly="readonly" :style="{height:(fileTextAreaHeight + 'px')}"
                      style="background: #000000; color: #FFFFFF; overflow:scroll; display: block; width: 100%;"
                      :value="currentFileContent"></textarea>
          </Row>
          <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="fileLoading">
            <Spin size="large"></Spin>
            <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
          </div>
        </div>
      </div>
    </Split>
  </div>
</template>
<script>
  import Vue from 'vue'
  import store from '@/store'
  import {mapActions} from 'vuex'
  import {genQueryParam, genSortParam} from '@/libs/queryparamhelper'
  import {numberFormat} from '@/libs/numberutil'
  import Editor from 'wangeditor'
  import 'wangeditor/release/wangEditor.min.css'
  import {oneOf} from '@/libs/tools'

  export default {
    //此名称与routers.js中name一致方可缓存
    name: 'systemlogs',
    components: {},
    data() {
      return {
        split1: 0.2,
        fileTextAreaHeight: 400,
        editor: null,
        fileLoading: false,
        currentFileName: null,
        currentFileContent: null,
        logTreeData: [
          {
            id: 1,
            title: 'logs',
            fileType: 2,
            expand: false,
            checked: true,
            selected: true,
            loading: false,
            filePath: null,
            children: []
          }
        ],
      }
    },
    methods: {
      ...mapActions([
        'SystemLogServ_GetChildrenFileList',
        'SystemLogServ_GetFileContent'
      ]),
      onRefresh(){
        this.fileLoading = true
        store.dispatch('SystemLogServ_GetFileContent', {
          params: null,
          urlparams: {filePath: this.currentFileName}
        }).then(() => {
          this.currentFileContent = store.getters.get_SystemLog_GetFileContentResult
          this.fileLoading = false
        }).catch(err => {
          this.fileLoading = false
        })
      },
      onLoadChildrenData(item, callback) {
        //加载子区域
        let parentDir = item.title === 'logs' ? null : item.title
        store.dispatch('SystemLogServ_GetChildrenFileList', {
          params: null,
          urlparams: {parentDir: parentDir}
        }).then(() => {
          let tempData = [];
          this.tempChildren = store.getters.get_SystemLog_GetChildrenFileListResult ? store.getters.get_SystemLog_GetChildrenFileListResult : [];
          this.tempChildren.forEach((dtoitem, index) => {
            tempData.push({
              id: dtoitem.id,
              title: dtoitem.name,
              fileType: dtoitem.fileType,
              filePath: (item.filePath === null ? dtoitem.name : item.filePath + '/' + dtoitem.name),
              expand: false,
              loading: false,
              children: dtoitem.fileType === 2 ? [] : null,
              parent: item
            })
          })
          callback(tempData)
        }).catch(err => {
          this.$Message.error(err)
        })
      },
      renderContent(h, {root, node, data}) {
        return h('span', {
          style: {
            display: 'inline-block',
            width: '100%'
          }
        }, [
          h('span', [
            h('Icon', {
              props: {
                type: data.fileType === 2 ? 'ios-folder-outline' : 'ios-paper-outline'
              },
              style: {
                marginRight: '8px'
              }
            }),
            h('span', {
              style: {
                // fontSize:'medium',
                // backgroundColor:'#2db7f5',
                // color:'#ffffff'
              },
              on: {
                click: () => {
                  if (data.fileType === 1) {
                    this.fileLoading = true
                    store.dispatch('SystemLogServ_GetFileContent', {
                      params: null,
                      urlparams: {filePath: data.filePath}
                    }).then(() => {
                      this.currentFileName = data.filePath
                      this.currentFileContent = store.getters.get_SystemLog_GetFileContentResult
                      // this.currentFileContent = this.currentFileContent.replace('\n', '<br/>')
                      this.fileLoading = false
                    }).catch(err => {
                      this.fileLoading = false
                    })
                  }

                }
              }
            }, data.title)
          ]),
          h('span', {
            style: {
              display: 'inline-block',
              float: 'right',
              marginRight: '5px'
            }
          }, [
            h('Button', {
              props: {
                size: 'small'
              },
              style: {
                marginRight: '5px'
              },
              on: {
                click: () => {
                  this.$Modal.confirm({
                    title: '确认删除文件',
                    content: '<p>注意：删除文件后不可恢复</p>',
                    onOk: () => {
                      store.dispatch('SystemLogServ_RemoveFile', {
                        params: null,
                        urlparams: {filePath: data.filePath}
                      }).then(() => {
                        let p = data.parent
                        if (p) {
                          let removeIndex = -1;
                          let length = p.children.length
                          for (var i = 0; i < length; i++) {
                            if (p.children[i].filePath === data.filePath) {
                              removeIndex = i
                              break
                            }
                          }
                          if (removeIndex !== -1) {
                            p.children.splice(removeIndex, 1)
                          }
                        }
                        this.$Message.success('删除成功')
                      }).catch(err => {
                        this.$Message.error(err)
                      })
                    },
                    onCancel: () => {
                    }
                  })
                }
              }
            }, '-')
          ])
        ])
      }
    },
    computed: {},
    mounted() {
      this.$nextTick(() => {
        console.log(this.$refs.fileTextArea)
        window.onresize = () => {
          this.fileTextAreaHeight = window.innerHeight - 175
        }
        this.fileTextAreaHeight = window.innerHeight - 175
      })
    }
  }
</script>
<style>
  .demo-split {
    height: 100%;
    border: 1px solid #dcdee2;
  }

  .demo-split-pane {
    padding: 10px;
  }
</style>
